module.exports = __webpack_public_path__ + "static/media/jack-o-lantern.b4c51822.svg";